import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-common-paused-yellow",
  "use": "icon-common-paused-yellow-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" fill=\"none\" id=\"icon-common-paused-yellow\">\n<rect y=\"0.00390625\" width=\"12\" height=\"12\" rx=\"6\" fill=\"#FFC923\" />\n<path d=\"M4.38086 4.03325V8.5645C4.38086 8.837 4.64648 9.01013 4.86523 8.8795L8.73867 6.56122C8.92805 6.44794 8.92805 6.14981 8.73867 6.03653L4.86523 3.71825C4.64648 3.58762 4.38086 3.76075 4.38086 4.03325Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol